// ============================================================
// KREATINAS+ - Shopify Theme JavaScript
// ============================================================

// SCROLL REVEAL
const reveals = document.querySelectorAll('.fade-up');
const ro = new IntersectionObserver(entries=>{
  entries.forEach((e,i)=>{
    if(e.isIntersecting){
      setTimeout(()=>e.target.classList.add('vis'), i*80);
    }
  });
},{threshold:0.1});
reveals.forEach(el=>ro.observe(el));

// FAIL-SAFE: jei observeris kažkodėl nesuveiktų, po 1,8 s parodome visas sekcijas,
// kad turinys niekada neliktu nematomas / „juodas“.
setTimeout(function(){
  document.querySelectorAll('.fade-up:not(.vis)').forEach(function(el){ el.classList.add('vis'); });
}, 1800);

// PURITY BARS
const barObs = new IntersectionObserver(entries=>{
  entries.forEach(e=>{
    if(e.isIntersecting){
      e.target.querySelectorAll('.purity-bar-fill').forEach((bar,i)=>{
        const w = parseFloat(bar.dataset.w);
        setTimeout(()=>{
          bar.style.width = (w*100)+'%';
          bar.classList.add('go');
        }, i*150+200);
      });
    }
  });
},{threshold:0.3});
document.querySelectorAll('#purityBars').forEach(el=>barObs.observe(el));

// ============================================================
// KREPŠELIS + CHECKOUT - pilna sistema
// ============================================================

let localCart = [];

// ── „Greitas suruošimas“ (+2 €) upsell ─────────────────────────
const EXPRESS_VARIANT_ID = 58276733976960;   // „Greitas suruošimas“ (+2 €)

// ── Gertuvės dovana - IŠJUNGTA (nėra atsargų) ──────────────────────
const GIFT_VARIANT_ID = null;                     // IŠJUNGTA: gertuvė nebepridėdama
const GIFT_THRESHOLD = 20;                        // (nebenaudojama, kol GIFT_VARIANT_ID = null)

// Palyginamosios kainos imamos iš Shopify (snippets/kp-compare-at.liquid); rodoma tik kur Shopify nurodyta „Compare-at price“
const COMPARE_AT = window.KP_COMPARE_AT || {};
const FREE_SHIPPING = 39;
const DELIVERY_OMNIVA = 3.90;
const DELIVERY_VENIPAK = 7.90;
const COD_FEE = 1.99;

// Aktyvus pristatymo būdas
let cartDeliveryMethod = 'omniva';   // krepšelyje
let cartPaymentMethod  = 'online';   // online | cod
let chkDeliveryMethod  = 'omniva';   // checkout
let chkPaymentMethod   = 'online';   // mokėjimo būdas

// ── Produktų katalogas (varianto ID → premium pavadinimas/nuotrauka krepšelyje) ──
function productCatalog() {
  return {
    57551875801472: { name: 'Bulk kreatino monohidratas 250 g',          image: window.KP_IMG_250 },
    57566914838912: { name: 'Bulk kreatino monohidratas 500 g',          image: window.KP_IMG_500 },
    57566932926848: { name: 'Bulk kreatino monohidratas 2×500 g',        image: window.KP_IMG_BUNDLE },
    58443009655168: { name: 'Genetic Nutrition Creapure 500 g',          image: window.KP_IMG_CREAPURE },
    58707592085888: { name: 'Iconic™ Shaker Bottle 750ml, Balta',       image: window.KP_IMG_SHAKER_WHITE },
    58707592118656: { name: 'Iconic™ Shaker Bottle 750ml, Juoda',       image: window.KP_IMG_SHAKER_BLACK }
  };
}

function updateNavCount(count) {
  const el = document.getElementById('navCartCount');
  if (el) el.textContent = count;
}

// ── Sinchronizacija iš Shopify serverio krepšelio (VIENINTELIS tiesos šaltinis) ──
function syncCartFromServer() {
  return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(r => r.json())
    .then(cart => {
      const cat = productCatalog();
      localCart = (cart.items || []).map(it => {
        const c = cat[it.variant_id] || {};
        const nm = c.name || it.product_title || it.title;
        return {
          name: nm,
          price: it.final_price / 100,
          orig: it.original_price / 100,
          qty: it.quantity,
          variantId: it.variant_id,
          key: it.key,
          type: 'Vienkartinis',
          image: c.image || it.image || getImageByName(nm)
        };
      });
      updateCartUI();
      reconcileCart();
      return cart;
    })
    .catch(() => { updateCartUI(); });
}

// ── Pridėjimas į krepšelį (serveris + sinchronizacija) ────
function addToShopifyCart(variantId, btn, name, priceOnce, imageUrl) {
  const id = parseInt(variantId, 10);
  if (!id || isNaN(id)) return;

  const lbl = btn ? (btn.querySelector('.btn-label-once') || btn.querySelector('.btn-label-sub')) : null;
  const orig = lbl ? lbl.textContent : '';
  if (lbl) lbl.textContent = '…';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: id, quantity: 1 })
  })
  .then(r => {
    if (!r.ok) return r.json().then(e => { throw new Error((e && e.description) || 'add failed'); });
    return r.json();
  })
  .then(() => syncCartFromServer())
  .then(() => {
    if (btn) {
      btn.classList.add('added');
      if (lbl) lbl.textContent = '✓ Pridėta!';
      setTimeout(() => { btn.classList.remove('added'); if (lbl) lbl.textContent = orig; }, 2000);
    }
    setTimeout(() => openCart(), 200);
  })
  .catch(err => {
    console.error('Pridėjimo klaida:', err);
    if (lbl) lbl.textContent = orig;
    alert('Atsiprašome, šios prekės šiuo metu negalima įdėti į krepšelį.');
  });
}

function getVariantIdByName(name) {
  return {
    'Bulk™ 250g':        57551875801472,
    'Bulk™ 500g':        57566914838912,
    'Bulk™ 1000g':       57566932926848,
    'Bulk™ 2×500g Bundle': 57566932926848,
    'Bulk kreatino monohidratas 250 g':   57551875801472,
    'Bulk kreatino monohidratas 500 g':   57566914838912,
    'Bulk kreatino monohidratas 2×500 g': 57566932926848,
    'Bulk kreatino monohidratas Creapure 500 g': 58443009655168
  }[name] || null;
}

function getImageByName(name) {
  if (name.includes('Shaker')) return window.KP_IMG_SHAKER_WHITE || window.KP_IMG_SHAKER || '';
  if (name.includes('250')) return window.KP_IMG_250 || '';
  if (name.includes('2×') || name.includes('Bundle') || name.includes('1000')) return window.KP_IMG_BUNDLE || '';
  if (name.includes('Creapure') || name.includes('creapure')) return window.KP_IMG_CREAPURE || '';
  return window.KP_IMG_500 || '';
}

// ── Pristatymo kainos ──────────────────
function getDeliveryCost(method, subtotal) {
  if (subtotal >= FREE_SHIPPING) return 0;
  return method === 'venipak' ? DELIVERY_VENIPAK : DELIVERY_OMNIVA;
}

// ── Krepšelio pristatymo pasirinkimas ─────────────
function selectCartDelivery(method) {
  cartDeliveryMethod = method;
  updateCartUI();
}

// ── Krepšelio mokėjimo pasirinkimas ─────────────
function selectCartPayment(method) {
  cartPaymentMethod = method;
  const codRow = document.getElementById('cartCodRow');
  if (codRow) codRow.style.display = method === 'cod' ? 'flex' : 'none';
  updateCartUI();
}

// ── KREPŠELIO UI ─────────────
function updateCartUI() {
  const expressItem = EXPRESS_VARIANT_ID ? localCart.find(i => i.variantId === EXPRESS_VARIANT_ID) : null;
  const expressActive = !!expressItem;
  const expressFee = expressActive ? expressItem.price * expressItem.qty : 0;
  const giftItem = GIFT_VARIANT_ID ? localCart.find(i => i.variantId === GIFT_VARIANT_ID) : null;
  const giftPrice = giftItem ? giftItem.price * giftItem.qty : 0;
  const products = localCart.filter(i =>
    i.variantId !== EXPRESS_VARIANT_ID && i.variantId !== GIFT_VARIANT_ID);

  const productsSubtotal = products.reduce((s, i) => s + i.price * i.qty, 0);
  const subtotal = productsSubtotal;                      // „Prekės“ - gertuvė dovana, į sumą nesk aiiuojama
  const count    = products.reduce((s, i) => s + i.qty, 0) + (giftItem ? giftItem.qty : 0);
  const freeShip = productsSubtotal >= FREE_SHIPPING;     // be gertuvės (ji nemokama)
  const shipping = getDeliveryCost(cartDeliveryMethod, productsSubtotal);
  const cod      = cartPaymentMethod === 'cod' ? COD_FEE : 0;
  const grand    = subtotal + expressFee + shipping + cod;

  // „Sutaupote“ - skirtumas tarp standartinės (palyginamosios) ir akcijinės kainos
  let savings = 0;
  let originalProducts = 0;
  products.forEach(i => {
    // Lyginame su standartine (Compare-at) kaina, o jei jos nėra, su kaina prieš akcijos nuolaidą
    const c = Math.max(COMPARE_AT[i.variantId] || 0, i.orig || 0, i.price);
    originalProducts += c * i.qty;
    if (c > i.price) savings += (c - i.price) * i.qty;
  });
  // Gertuvė - dovana: jos standartinė vertė pridėdama prie sutaupytos sumos
  if (giftPrice > 0) savings += giftPrice;

  updateNavCount(count);
  const badge = document.getElementById('cartCountBadge');
  if (badge) badge.textContent = count;

  const isEmpty = products.length === 0;
  const emptyEl = document.getElementById('cartEmpty');
  const footerEl = document.getElementById('cartFooter');
  if (emptyEl) emptyEl.style.display = isEmpty ? 'block' : 'none';
  if (footerEl) footerEl.style.display = isEmpty ? 'none' : 'block';

  // Visada atstatom „Pirkti“ mygtuką (kad neliktu užstrigus „Kraunama...“)
  const coBtn = document.querySelector('.cart-checkout-btn');
  if (coBtn) { coBtn.textContent = 'Pirkti →'; coBtn.disabled = false; }

  // Prekiu sąrašas
  const itemsEl = document.getElementById('cartItems');
  if (itemsEl) {
    itemsEl.querySelectorAll('.cart-item').forEach(e => e.remove());
    products.forEach((item, idx) => {
      const div = document.createElement('div');
      div.className = 'cart-item';
      const weight = item.name.includes('2×') ? '2×500' : item.name.includes('250') ? '250' : '500';
      const imgSrc = item.image || getImageByName(item.name);
      const imgHtml = imgSrc
        ? `<div class="ci-img"><img src="${imgSrc}" alt="${item.name}" loading="lazy"></div>`
        : `<div class="ci-img ci-img-text">${weight}g</div>`;
      const cmp = Math.max(COMPARE_AT[item.variantId] || 0, item.orig || 0);
      const itemSaving = (cmp && cmp > item.price) ? (cmp - item.price) * item.qty : 0;
      const priceBlockHtml = itemSaving > 0.001
        ? `<div class="ci-price"><span class="ci-price-was">${(cmp * item.qty).toFixed(2).replace('.', ',')}€</span>${(item.price * item.qty).toFixed(2).replace('.', ',')}€</div>
           <div class="ci-save">Sutaupote ${itemSaving.toFixed(2).replace('.', ',')}€</div>`
        : `<div class="ci-price">${(item.price * item.qty).toFixed(2).replace('.', ',')}€</div>`;
      div.innerHTML = `
        ${imgHtml}
        <div class="ci-info">
          <div class="ci-name">${item.name}</div>
          <div class="ci-qty">
            <button class="ci-qty-btn" onclick="changeQty('${item.key}',-1)">−</button>
            <span class="ci-qty-num">${item.qty}</span>
            <button class="ci-qty-btn" onclick="changeQty('${item.key}',1)">+</button>
          </div>
        </div>
        <div style="display:flex;flex-direction:column;align-items:flex-end;gap:8px">
          ${priceBlockHtml}
          <button class="ci-remove" onclick="removeItem('${item.key}')">✕</button>
        </div>`;
      itemsEl.appendChild(div);
    });
  }

  // Pristatymo variantai - atnaujina kainas
  const omnivaPrice = freeShip ? 'Nemokamas' : DELIVERY_OMNIVA.toFixed(2).replace('.',',') + '€';
  const venipakPrice = freeShip ? 'Nemokamas' : DELIVERY_VENIPAK.toFixed(2).replace('.',',') + '€';
  const cdpOmnivaP = document.getElementById('cdpOmnivaPrice');
  const cdpVenipakP = document.getElementById('cdpVenipakPrice');
  if (cdpOmnivaP) cdpOmnivaP.textContent = omnivaPrice;
  if (cdpVenipakP) cdpVenipakP.textContent = venipakPrice;

  // Sumos
  const subtotalEl = document.getElementById('cartSubtotal');
  const shippingEl = document.getElementById('cartShipping');
  const freeNoteEl = document.getElementById('cartFreeNote');
  const shipRowEl  = document.getElementById('cartShippingRow');
  const totalEl    = document.getElementById('cartTotal');
  if (subtotalEl) {
    if (savings > 0.001) {
      const orig = (originalProducts + giftPrice).toFixed(2).replace('.',',');
      subtotalEl.innerHTML = '<s style="opacity:.5;font-weight:400;margin-right:6px">' + orig + '€</s>' + subtotal.toFixed(2).replace('.',',') + '€';
    } else {
      subtotalEl.textContent = subtotal.toFixed(2).replace('.',',') + '€';
    }
  }
  if (shippingEl) shippingEl.textContent = freeShip ? 'Nemokamas' : shipping.toFixed(2).replace('.',',') + '€';
  if (freeNoteEl) freeNoteEl.style.display = freeShip ? 'flex' : 'none';
  if (shipRowEl)  shipRowEl.style.display  = freeShip ? 'none' : 'flex';
  if (totalEl)    totalEl.textContent = grand.toFixed(2).replace('.',',') + '€';

  // „Greitas suruošimas“ upsell atvaizdavimas
  const expBlock = document.getElementById('cartExpress');
  if (expBlock) expBlock.style.display = EXPRESS_VARIANT_ID ? 'block' : 'none';
  const expToggle = document.getElementById('cartExpressToggle');
  if (expToggle) expToggle.checked = expressActive;
  const expRow = document.getElementById('cartExpressRow');
  if (expRow) expRow.style.display = expressActive ? 'flex' : 'none';
  const expFeeEl = document.getElementById('cartExpressFee');
  if (expFeeEl) expFeeEl.textContent = expressFee.toFixed(2).replace('.',',') + '€';

  // „Sutaupote“ eilutė
  const savingsRow = document.getElementById('cartSavingsRow');
  const savingsAmt = document.getElementById('cartSavingsAmt');
  if (savingsRow) savingsRow.style.display = savings > 0.001 ? 'flex' : 'none';
  if (savingsAmt) savingsAmt.textContent = '-' + savings.toFixed(2).replace('.',',') + '€';

  // Gertuvės dovanos pranešimas (išjungta - elementas pašalintas)
  const giftBanner = document.getElementById('cartGiftBanner');
  if (giftBanner) {
    const giftEligible = GIFT_VARIANT_ID && productsSubtotal >= GIFT_THRESHOLD;
    giftBanner.style.display = giftEligible ? 'flex' : 'none';
  }

  // Progreso juosta (krepšelio viršuje) - visada rodoma, kai krepšelyje yra prekių
  const prog = document.getElementById('cartFreeProgress');
  if (prog) {
    if (productsSubtotal > 0) {
      prog.style.display = 'block';
      const fillEl = document.getElementById('cfpFill');
      const txtEl  = document.getElementById('cfpText');
      if (freeShip) {
        prog.classList.add('is-free');
        if (fillEl) fillEl.style.width = '100%';
        if (txtEl) txtEl.innerHTML = '✓ Pristatymas <strong>nemokamas</strong>, sutaupai ' + DELIVERY_OMNIVA.toFixed(2).replace('.',',') + ' €';
      } else {
        prog.classList.remove('is-free');
        const pct = Math.min((productsSubtotal / FREE_SHIPPING) * 100, 100);
        if (fillEl) fillEl.style.width = pct + '%';
        if (txtEl) txtEl.innerHTML = '🚚 Liko <strong>' + (FREE_SHIPPING - productsSubtotal).toFixed(2).replace('.',',') + ' €</strong> iki <b>nemokamo pristatymo</b>';
      }
    } else { prog.style.display = 'none'; }
  }

  // Upsell blokas (snippets/kp-cart-upsell.liquid): Magnis / gertuvė -20 % prie kreatino
  if (typeof window.kpCartUpsell === 'function') {
    try { window.kpCartUpsell(products, productsSubtotal, freeShip); } catch (e) { console.error(e); }
  }
}

// ── Krepšelio auto-derinimas: „Greitas suruošimas“ (gertuvė išjungta) ──
let _cartBusy = false;
function expressOptedOut() {
  try { return localStorage.getItem('kp_express_optout') === '1'; } catch (e) { return false; }
}
function _cartAct(url, body) {
  _cartBusy = true;
  fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
    .then(() => { _cartBusy = false; syncCartFromServer(); })
    .catch(() => { _cartBusy = false; });
}
function reconcileCart() {
  if (_cartBusy) return;
  const realProducts = localCart.filter(i =>
    i.variantId !== EXPRESS_VARIANT_ID && i.variantId !== GIFT_VARIANT_ID);
  const expressItem = localCart.find(i => i.variantId === EXPRESS_VARIANT_ID);
  const giftItem = localCart.find(i => i.variantId === GIFT_VARIANT_ID);

  // 1) Gertuvė - IŠJUNGTA (GIFT_VARIANT_ID = null): nepridėdama
  if (GIFT_VARIANT_ID) {
    const realSubtotal = realProducts.reduce((s, i) => s + ((i.price || 0) * i.qty), 0);
    const giftEligible = realSubtotal >= GIFT_THRESHOLD;
    if (giftEligible && !giftItem)                     return _cartAct('/cart/add.js',    { id: GIFT_VARIANT_ID, quantity: 1 });
    if (giftEligible && giftItem && giftItem.qty > 1)  return _cartAct('/cart/change.js', { id: giftItem.key, quantity: 1 });
    if (!giftEligible && giftItem)                     return _cartAct('/cart/change.js', { id: giftItem.key, quantity: 0 });
  }

  // 2) „Greitas suruošimas“ - opt-in: šalinamas tik kai krepšelis tuščias
  if (EXPRESS_VARIANT_ID) {
    if (realProducts.length === 0 && expressItem)
      return _cartAct('/cart/change.js', { id: expressItem.key, quantity: 0 });
  }
}

function toggleExpressHandling(on) {
  if (!EXPRESS_VARIANT_ID) return;
  if (on) {
    try { localStorage.removeItem('kp_express_optout'); } catch (e) {}
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: EXPRESS_VARIANT_ID, quantity: 1 })
    }).then(() => syncCartFromServer()).catch(() => syncCartFromServer());
  } else {
    try { localStorage.setItem('kp_express_optout', '1'); } catch (e) {}
    const item = localCart.find(i => i.variantId === EXPRESS_VARIANT_ID);
    if (!item) return;
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: 0 })
    }).then(() => syncCartFromServer()).catch(() => syncCartFromServer());
  }
}

function changeQty(key, delta) {
  const item = localCart.find(i => i.key === key);
  if (!item) return;
  const newQty = Math.max(0, item.qty + delta);
  fetch('/cart/change.js', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: newQty })
  }).then(r => r.json()).then(() => syncCartFromServer()).catch(() => syncCartFromServer());
}

function removeItem(key) {
  fetch('/cart/change.js', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  }).then(r => r.json()).then(() => syncCartFromServer()).catch(() => syncCartFromServer());
}

// ── KREPŠELIO ATIDARYMAS/UŽDARYMAS ───────────
function openCart() {
  document.getElementById('cartPanel').classList.add('open');
  document.getElementById('cartOverlay').classList.add('open');
  document.body.style.overflow = 'hidden';
  var coBtn = document.querySelector('.cart-checkout-btn');
  if (coBtn) { coBtn.textContent = 'Pirkti →'; coBtn.disabled = false; }
}
function closeCart() {
  document.getElementById('cartPanel').classList.remove('open');
  document.getElementById('cartOverlay').classList.remove('open');
  document.body.style.overflow = '';
}
function closeAll() {
  closeCart();
}

// ── Tiesiai į Shopify checkout (serverio krepšelis = tiesos šaltinis) ──
function proceedToShopifyCheckout() {
  if (localCart.length === 0) return;

  const btn = document.querySelector('.cart-checkout-btn');
  if (btn) { btn.textContent = 'Kraunama...'; btn.disabled = true; }
  const reset = () => { if (btn) { btn.textContent = 'Pirkti →'; btn.disabled = false; } };

  const deliveryLabel = cartDeliveryMethod === 'venipak'
    ? 'Venipak kurjeriu (7,90€)'
    : 'Omniva paštomate (3,90€)';
  const paymentLabel = cartPaymentMethod === 'cod'
    ? ' | Mokėjimas: Grynaisiais pristatymo metu (+1,99€)'
    : ' | Mokėjimas: Internetu';
  const deliveryNote = 'Pristatymas: ' + deliveryLabel + paymentLabel;

  fetch('/cart/update.js', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ note: deliveryNote })
  })
  .then(() => fetch('/cart.js'))
  .then(r => r.json())
  .then(cart => {
    if (cart && cart.item_count > 0) {
      window.location.href = '/checkout';
    } else {
      reset();
      alert('Jūsų krepšelis tuščias.');
    }
  })
  .catch(err => {
    console.error('Checkout klaida:', err);
    window.location.href = '/cart';
  });
}

// Suderinamumo stub
function openCheckout() { proceedToShopifyCheckout(); }
function closeCheckout() {}

// ── Naujienlaiškio prenumerata ────────────
function subscribeNewsletter(btn) {
  const input = btn.previousElementSibling;
  const email = input.value.trim();
  if (!email || !email.includes('@')) {
    input.style.borderColor = 'rgba(200,80,80,0.6)';
    setTimeout(() => input.style.borderColor = '', 2000);
    return;
  }
  fetch('/contact', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: `form_type=customer&email=${encodeURIComponent(email)}&contact[tags]=newsletter`
  }).finally(() => {
    btn.textContent = '✓ Užprenumeruota!';
    btn.disabled = true;
    input.value = '';
    input.disabled = true;
    setTimeout(() => {
      btn.textContent = 'Prenumeruoti';
      btn.disabled = false;
      input.disabled = false;
    }, 4000);
  });
}

// ── Mobilaus meniu valdymas ─────────────
function toggleMobileMenu() {
  const nav = document.getElementById('mobileNav');
  const btn = document.getElementById('mobileMenuBtn');
  const isOpen = nav.classList.contains('open');
  if (isOpen) {
    closeMobileMenu();
  } else {
    nav.classList.add('open');
    btn.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
}

function closeMobileMenu() {
  const nav = document.getElementById('mobileNav');
  const btn = document.getElementById('mobileMenuBtn');
  nav.classList.remove('open');
  btn.classList.remove('open');
  document.body.style.overflow = '';
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.mobile-nav-links a').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var href = this.getAttribute('href') || '';
      var hashIndex = href.indexOf('#');
      if (hashIndex === -1) { closeMobileMenu(); return; }
      var id = href.slice(hashIndex);
      var target = document.querySelector(id);
      if (target) {
        e.preventDefault();
        closeMobileMenu();
        setTimeout(function() {
          var navH = document.querySelector('nav') ? document.querySelector('nav').offsetHeight : 60;
          var top = target.getBoundingClientRect().top + window.scrollY - navH - 8;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }, 360);
      } else {
        closeMobileMenu();
      }
    });
  });
});

// ── Produkto galerijos miniatiuru perjungimas ───────────
function swapProdImg(imgId, src, btn) {
  var img = document.getElementById(imgId);
  if (img && img.getAttribute('src') !== src) {
    img.style.opacity = '0';
    var pre = new Image();
    var show = function(){ img.src = src; img.style.opacity = '1'; };
    pre.onload = show; pre.onerror = show;
    pre.src = src;
  }
  if (btn && btn.parentElement) {
    var thumbs = btn.parentElement.querySelectorAll('button');
    thumbs.forEach(function(t){ t.classList.remove('is-active'); });
    btn.classList.add('is-active');
  }
}

// ── „Atgal“ mygtuko (bfcache) atstatymas + krepšelio sinchronizacija ──
window.addEventListener('pageshow', function(e) {
  var coBtn = document.querySelector('.cart-checkout-btn');
  if (coBtn) { coBtn.textContent = 'Pirkti →'; coBtn.disabled = false; }
  if (typeof syncCartFromServer === 'function') syncCartFromServer();
});

// ── Pradinė krepšelio sinchronizacija ──
document.addEventListener('DOMContentLoaded', function() {
  if (typeof syncCartFromServer === 'function') syncCartFromServer();
});
